import React, { FC } from 'react';

import { Box, Icon, OnClick } from '@rbilabs/components-library';

import ActionButton, { ActionButtonVariants, IActionButtonProps } from 'components/action-button';

interface IRefreshButtonProps extends IActionButtonProps {
  onClick: OnClick;
}

export const RefreshButton: FC<IRefreshButtonProps> = ({ children, onClick }) => {
  return (
    <Box center width="100%" margin="1rem auto">
      <ActionButton
        variant={ActionButtonVariants.OUTLINE}
        onClick={onClick}
        startIcon={<Icon icon="refresh" color="primary" aria-hidden />}
      >
        {children}
      </ActionButton>
    </Box>
  );
};
